'use client';

import { Suspense } from 'react';
import { useUTMTracking } from '@/shared/hooks/use-utm-tracking';

/**
 * Internal component that uses the hook
 * Wrapped in Suspense because useSearchParams needs it
 */
function UTMTrackerInner() {
  useUTMTracking();
  return null;
}

/**
 * Client component to track UTM parameters
 * Add this to your root layout to capture marketing attribution
 *
 * @example
 * ```tsx
 * <AppContextProvider>
 *   <UTMTracker />
 *   {children}
 * </AppContextProvider>
 * ```
 */
export function UTMTracker() {
  return (
    <Suspense fallback={null}>
      <UTMTrackerInner />
    </Suspense>
  );
}

